import { useQuery } from "@tanstack/react-query";
import api from "apis";
import { GetLatestArchivesParams } from "apis/data-contracts";

const useLatestArchivesQuery = () => {
  const query: GetLatestArchivesParams = {
    page: 0,
    size: 5,
  };

  return useQuery({
    queryKey: api.dashboard.getLatestArchivesKey(query),
    queryFn: () => api.dashboard.getLatestArchives(query),
    select: (res) => res.data.result,
  });
};

export default useLatestArchivesQuery;
